export const todoActionConstansts = {
  TODO_FETCH_REQUESTED: "TODO_FETCH_REQUESTED",
  ADD_NEW_TODO: "ADD_NEW_TODO",
  DELETE_ALL_TODOS: "DELETE_ALL_TODOS",
  DELETE_ONE_TODO: "DELETE_ONE_TODO",
  UPDATE_SINGLE_TODO: "UPDATE_SINGLE_TODO",
};
